/* unplugin-vue-components disabled */import { render } from "./order-invalid.vue?vue&type=template&id=14d90ce6&scoped=true"
const script = {}

import "./order-invalid.vue?vue&type=style&index=0&id=14d90ce6&scoped=true&lang=less"

import exportComponent from "E:\\ProjectsWorkspaces\\WebStormProjects\\OCHS-Product-Disda-Online-Car-Hailing-H5\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_7401bc125e2957ce4091f6809056b31d\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d90ce6"]])

export default __exports__